var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logout",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.947,
    viewBox: "0 0 16 15.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_67",
    "data-name": "Raggruppa 67",
    transform: "translate(7.362 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_66",
    "data-name": "Raggruppa 66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_24",
    "data-name": "Tracciato 24",
    d: "M.664,15.468h5.98a.665.665,0,0,0,.664-.664V2.843a.665.665,0,0,0-.664-.664H.664A.664.664,0,0,1,.664.85h5.98A2,2,0,0,1,8.638,2.843V14.8A2,2,0,0,1,6.645,16.8H.664a.664.664,0,1,1,0-1.329Z",
    transform: "translate(0 -0.85)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_69",
    "data-name": "Raggruppa 69",
    transform: "translate(0 3.322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_68",
    "data-name": "Raggruppa 68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_25",
    "data-name": "Tracciato 25",
    d: "M170.3,111.343l4.04-3.987a.664.664,0,1,1,.933.946l-2.887,2.849h7.736a.664.664,0,0,1,0,1.329h-7.736l2.887,2.849a.664.664,0,1,1-.933.946l-4.04-3.987a.664.664,0,0,1,0-.946Z",
    transform: "translate(-170.1 -107.165)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.cc85a09a32e88381c5fb377a6d582386.svg";
export { ForwardRef as ReactComponent };